import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import PdfViewer from "./PdfViewer";
import MarkdownViewer from "./MarkdownViewer";
import TxtViewer from "./TxtViewer";

const DynamicFileViewer = ({ fileUrl, initialPage, filename }) => {
  const [fileType, setFileType] = useState("");

  useEffect(() => {
    const getFileType = () => {
      if (!filename) return "";
      const extension = filename.split(".").pop().toLowerCase();
      return extension;
    };
    setFileType(getFileType());
  }, [filename]);

  const renderViewer = () => {
    try {
      const supportedFormats = {
        pdf: <PdfViewer fileUrl={fileUrl} initialPage={initialPage} key={fileUrl} />,
        docx: <PdfViewer fileUrl={fileUrl} initialPage={initialPage} key={fileUrl} />, // Will be given a PDF URL by the backend conversion
        md: <MarkdownViewer fileUrl={fileUrl} />,
        txt: <TxtViewer fileUrl={fileUrl} />,
        default: (
          <div className="text-status-critical font-semibold p-4">
            Unsupported file type: .{fileType}
          </div>
        ),
      };
      return supportedFormats[fileType] ? supportedFormats[fileType] : supportedFormats.default;
    } catch (error) {
      console.log("Error while rendering the file", error);
    }
  };

  if (!fileUrl) {
    return <div className="p-4 text-muted">No file selected.</div>;
  }

  return (
    <div className="w-full">
      {renderViewer()}
    </div>
  );
};

DynamicFileViewer.defaultProps = {
  initialPage: 1,
};

DynamicFileViewer.propTypes = {
  filename: PropTypes.string,
  fileUrl: PropTypes.string,
  initialPage: PropTypes.number,
};

export default DynamicFileViewer;
